module.exports = __webpack_public_path__ + "static/img/banner-3.a3058b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-3.jpg
// module id = ctal
// module chunks = 1